window.addEventListener('load', () => {
  setTimeout(() => {
    function setCookie(name, value, days) {
      const d = new Date();
      d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
      document.cookie = `${name}=${value}; expires=${d.toUTCString()}; path=/`;
    }

    function getCookie(name) {
      const match = document.cookie.split('; ').find(row => row.startsWith(name + '='));
      return match ? match.split('=')[1] : null;
    }

    const popup = document.getElementById('popup');
    if (!popup) return;

    document.querySelectorAll('a[href="#popup"], [data-open-popup]')
      .forEach(el => {
        el.addEventListener('click', (ev) => {
          ev.preventDefault();
          popup.classList.add('open');
        });
      });

    const blockAuto = getCookie('sloane_popup_submitted') === '1' || getCookie('sloane_popup_closed') === '1';
    if (blockAuto) {
    } else {
      popup.classList.add('open');
    }

    const form = popup.querySelector('form.popup-form');
    if (!form) return;

    popup
      .querySelectorAll('[data-popup-close]')
      ?.forEach(element => {
        element.addEventListener('click', () => {
          popup.classList.remove('open');
          setCookie('sloane_popup_closed', '1', 1);
        });
      });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const formData = new FormData(form);

      try {
        const response = await fetch('https://n8n.ourimo.pt/webhook/sloane-form', {
          method: 'POST',
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
          body: new URLSearchParams(formData)
        });

        if (!response.ok) {
          console.error('An error ocurred trying to send your email, please try again', response.status);
          return;
        }

        const formContent = popup.querySelector('.content-form');
        const codeContent = popup.querySelector('.content-code'); // typo corrigido

        if (formContent) {
          formContent.style.display = 'none';
        }

        if (codeContent) {
          codeContent.style.display = 'flex';
        }

        console.log('Email sent successfully!');

        setCookie('sloane_popup_submitted', '1', 30);
        setCookie('sloane_popup_closed', '', -1);
      } catch (err) {
        console.error('Unexpected error happened, please try again.', err);
      }
    });

  }, 3000);
});